<button [type]="buttonType" (click)="handleClick($event)" class="button" [ngClass]="type" [disabled]="disabled">
    <img *ngIf="iconSrc" [src]="iconSrc" alt="button-icon">
    <p>{{buttonText}}</p>
</button>